// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"53181bb0","644":"ed9edde8","702":"01b8cf37","890":"1fd3d45a","921":"6ae376c7","922":"57f31785"}[chunkId] + ".chunk.js";
};